const state = {
    inspectionUseInformationFields: [
        {
            key: "time",
            label: "檢驗時間",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "inspector",
            label: "檢測人員",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "code",
            label: "檢驗項目",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "standardValue",
            label: "標準值",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "inspectionValue",
            label: "檢驗值",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
        {
            key: "result",
            label: "檢驗結果",
            sortable: false,
            class: "font-family-dfyuanstd-w5 table-col-hight"
        },
    ],
    inspectionUseInformationData: {},
    singleProcess: true,
}
const getters = {
    get_inspectionUseInformationFields: state => {
        return state.inspectionUseInformationFields
    },
    get_inspectionUseInformationData: state => {
        return state.inspectionUseInformationData
    },
    get_inspectionUseSingleProcess: state => {
        return state.singleProcess
    },
}
const actions = {
    set_inspectionUseInformationFields(context, array) {
        context.commit('SET_INSPECTIONUSEINFORMATIONFIELDS', array);
    },
    set_inspectionUseInformationData(context, obj) {
        context.commit('SET_INSPECTIONUSEINFORMATIONDATA', obj);
    },
    set_inspectionUseSingleProcess(context, boolean) {
        context.commit('SET_INSPECTIONUSESINGLEPROCESS', boolean);
    },
    clear_inspectionUseInformation(context) {
        context.commit('CLEAR_INSPECTIONUSEINFORMATION');
    }
}
const mutations = {
    SET_INSPECTIONUSEINFORMATIONFIELDS(state, array) {
        state.inspectionUseInformationFields = array;
    },
    SET_INSPECTIONUSEINFORMATIONDATA(state, obj) {
        state.inspectionUseInformationData = obj;
    },
    SET_INSPECTIONUSESINGLEPROCESS(state, boolean) {
        state.singleProcess = boolean;
    },
    CLEAR_INSPECTIONUSEINFORMATION(state) {
        state.inspectionUseInformationData = {};
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/inspectionUseInformation.js